export default __webpack_public_path__ + "static/media/LockGreen.775fb99a.svg";